import React, { useState, useEffect }  from 'react';
import ReservationStyle from '../styles/pages/ReserveAnimation.module.scss'
import { useSelector , useDispatch } from 'react-redux'
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useGetAnimationByIdQuery, useUpdateMutation } from '../services/AnimationsAPI';
import Loader from '../components/layout/Loader';
import { RootState } from '../store/GlobalStore'
import { AnimationRegisterFormData, Registration, AnimationRegisterResponse, errorAPI } from '../utils/Interface'
import PageHeader from '../components/layout/PageHeader'
import { addNotification } from '../store/slices/notificationSlice';
import { type BlocksContent, BlocksRenderer } from "@strapi/blocks-react-renderer";
import NotificationContainer from '../components/layout/NotificationContainer'
import { useTranslation } from 'react-i18next';
const ReserveAnimation: React.FC = () => {
    const { t, i18n  } = useTranslation();
    const { id } = useParams<{ id: string }>();
    const { data: animationData, error, isLoading, refetch } = useGetAnimationByIdQuery(Number(id), {
        refetchOnMountOrArgChange: true,
      });
    const authState = useSelector((state: RootState) => state.Auth);
    const dispatch = useDispatch();

    const [modifyAnimation, { isError, isSuccess }] = useUpdateMutation()
    const [nbParticipants, setNbParticipants] = useState<number>(1); 
    const [dejaParticipant, setDejaParticipant] = useState<boolean>(false);
    const navigate = useNavigate()
    const options : Intl.DateTimeFormatOptions   = { 
        weekday: 'short', 
        year: 'numeric',  
        month: 'short',  
        day: 'numeric',   
        hour: '2-digit',  
        minute: '2-digit'    
      };
    // Définir explicitement le type de l'état local
    const [animationDetails, setAnimationDetails] = useState<{
        id: number;
        title: string;
        description: BlocksContent;
        date: string;
        nombreParticipants: number;
    }>({
        id: 0,
        title: '',
        description: [],
        date: '',
        nombreParticipants: 0,
    });

     // Vérification de l'authentification au montage du composant
     useEffect(() => {
        if (!authState.user) {
            dispatch(
                addNotification({
                    message: "Vous devez être connecté pour réserver une animation.",
                    type: 'warning',
                })
            );
            navigate('/login');
            return;
        }
    }, [authState.user]);

    // Mettre à jour l'état local dès que animationData est disponible
    useEffect(() => {
        console.log("animationData",animationData)
        if (animationData) {
            console.log(animationData)
            setAnimationDetails({
                id: animationData.id,
                title: animationData.title,
                description: animationData.description,
                date: animationData.date,
                nombreParticipants: animationData.Inscriptions?.reduce((sum, inscription) => sum + inscription.participants, 0) || 0,
            });
            setDejaParticipant(animationData.Inscriptions?.some(inscription => inscription.user && inscription?.user?.id === authState.user?.id) || false);
            //console.log("animationData.description  ===>" + animationData.description)
        }
    }, [animationData]);


    if (isLoading) {
        return <Loader />;
    }

    if (error || !animationData) {
        return <div>Error occurred while fetching the animation details.</div>;
    }

    let  featuredImage : string = "";
    if(animationData && animationData.images?.length > 0){
        featuredImage= process.env.REACT_APP_BASE_URL + animationData.images[0]?.url
    }

    const handleClick = async () => {
        if(nbParticipants < 1){
            console.log("cqscfqs")
            dispatch(
            addNotification({
                message:
                    "Veuillez renseigner un nombre de participant",
                type: 'warning'
            }))
        }
        else{
        console.log('inscription')
        console.log(authState)
        console.log(animationDetails.nombreParticipants)
        const input : AnimationRegisterFormData ={animId: animationData.id, userId: authState.user!.id, participants: nbParticipants}
        
        try {
            const result: { data: AnimationRegisterResponse & errorAPI } = (await modifyAnimation(input)) as { data: AnimationRegisterResponse & errorAPI}
            console.log(result)
            if (result.data && result.data.status === 'success') {
                 // Mettre à jour l'état local avec les nouvelles données
                 setAnimationDetails(prevState => ({
                    ...prevState,
                    nombreParticipants: result.data.animation.Inscriptions?.reduce((sum, inscription) => sum + inscription.participants, 0) || 0
                }));
                setDejaParticipant(true);
                dispatch(
                    addNotification({
                        message:
                            "Vous êtes correctement inscrit à l'animation : " + animationData.title,
                        type: 'success'
                    })
                )
                navigate('/my-animations') // Rediriger l'utilisateur
            }
            else{
                throw new Error("Une erreur s'est produite lors de l'inscription")
            }
        } catch (error) {
            dispatch(
                addNotification({
                    message:
                        "Une erreur s'est produite lors de l'inscription à l'animation : " + animationData.title,
                    type: 'warning'
                })
            )
            navigate('/my-animations') // Rediriger l'utilisateur

            console.error('Failed to update user:', error)
        }}
    };

    const handleChange = (e : any) => {
        const inputValue = e.target.value;
        // Valide si c'est un nombre ou vide, et met à jour la valeur
        if (/^\d*$/.test(inputValue)) {
            setNbParticipants(inputValue);
        }
        console.log(nbParticipants)
    };
    

    return (
        <>
        <NotificationContainer />
        <div className={ReservationStyle.MainContainer}>
            {/* Structure identique à ta page de référence */}
            <PageHeader backTo='/animations' title={animationDetails.title} />

            <div className={ReservationStyle.AnimationContainer}>
                <div className={ReservationStyle.ContentWrapper}>
                 
                    
                    <div className={ReservationStyle.leftContent}>
                        <p className={ReservationStyle.participants}>{t('nb_inscrits')} : {animationDetails.nombreParticipants}</p>
                        <p className={ReservationStyle.price}>
                            {t('price')} : {animationData.price != null && animationData.price > 0 ? `${animationData.price}€` : t('free')}
                        </p>
                        <p className={ReservationStyle.date}>{new Date(animationData.date).toLocaleDateString(i18n.language, options)}</p>
                        
                        <div className={ReservationStyle.description}>
                            <BlocksRenderer content={animationDetails.description} />
                        </div>

                        <div className={ReservationStyle.FormZone}>
                            {dejaParticipant ? (
                                <>
                                    <p className={ReservationStyle.alreadyIn}>{t('already_reg')}</p>
                                    <Link to={`/animation-details/${animationDetails.id}`} className={ReservationStyle.seeLink}>{t('see_reg')}</Link>
                                </>
                            ) : (
                                <>
                                    <label htmlFor="nbParticipants">{t('how_many')} : </label>
                                    <div className={ReservationStyle.InputContainer}>
                                        <input
                                            id="nbParticipants"
                                            type="number"
                                            min="1"
                                            value={nbParticipants}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <button className={ReservationStyle.submitBtn} onClick={handleClick}>{t('reg')}</button>
                                </>
                            )}
                        </div>
                    </div>

                    <div className={ReservationStyle.rightContent}>
                        <img
                            key={id}
                            src={featuredImage}
                            alt={animationDetails.title}
                            className={ReservationStyle.mainImage}
                        />
                    </div>
                </div>
            </div>
        </div>
        </>
    );
};

export default ReserveAnimation;
